import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/logo1.jpeg";
import navIcon1 from "../assets/img/NavbarIcon1.png";
import navIcon2 from "../assets/img/NavbarIcon2.png";
import navIcon3 from "../assets/img/NavbarIcon3.png";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://github.com/Sansrita"><img src={navIcon1} alt="Icon" /></a>
              <a href="https://www.linkedin.com/in/sansrita-saha-068246228"><img src={navIcon2} alt="Icon" /></a>
              <a href="https://www.instagram.com/midnight_minutes_16/"><img src={navIcon3} alt="Icon" /></a>
            </div>
            <p>@Sansrita2023</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}